import { WEEKDAYS } from '../catalog/format'
import type { DraftWeek } from '../screens/settings/hoursForm'
import '../screens/settings/Settings.css'
import DayEditor from './DayEditor'

interface WeekEditorProps {
  week: DraftWeek
  onChange: (week: DraftWeek) => void
  // errors are keyed "day:index", as toWindows and errorsByWindow produce them.
  errors?: Record<string, string>
}

// WeekEditor edits a week of stretches. Settings -> Hours and the Dream Week
// planner share it, so a Dream Week and her working hours are literally the
// same shape, and "Use as my booking hours" is a straight copy.
export default function WeekEditor({ week, onChange, errors = {} }: WeekEditorProps) {
  return (
    <div className="hours-week">
      {WEEKDAYS.map((dayName, day) => (
        <DayEditor key={dayName} week={week} day={day} onChange={onChange} errors={errors} />
      ))}
    </div>
  )
}
